import React from 'react';
import { ChevronRight } from 'lucide-react';
import { useParams } from 'react-router-dom';
import { Breadcrumb, BreadcrumbItem, BreadcrumbLink, BreadcrumbList, BreadcrumbPage, BreadcrumbSeparator } from '@/components/ui/breadcrumb';

const CategoryBreadcrumbs = React.memo(() => {
  // Get category name directly from URL inside component to avoid prop dependencies
  const { categoryName } = useParams();
  const decodedCategoryName = categoryName ? decodeURIComponent(categoryName) : 'קטגוריה';

  return (
    <div className="mb-6 mt-0 relative z-10" dir="rtl">
      <Breadcrumb>
        <BreadcrumbList>
          <BreadcrumbItem>
            <BreadcrumbLink href="/">
              בית
            </BreadcrumbLink>
          </BreadcrumbItem>
          <BreadcrumbSeparator>
            <ChevronRight className="h-4 w-4 rotate-180" />
          </BreadcrumbSeparator>
          <BreadcrumbItem>
            <BreadcrumbLink href="/products">
              קטגוריות
            </BreadcrumbLink>
          </BreadcrumbItem>
          <BreadcrumbSeparator>
            <ChevronRight className="h-4 w-4 rotate-180" />
          </BreadcrumbSeparator>
          <BreadcrumbItem>
            <BreadcrumbPage>{decodedCategoryName}</BreadcrumbPage>
          </BreadcrumbItem>
        </BreadcrumbList>
      </Breadcrumb>
    </div>
  );
});

CategoryBreadcrumbs.displayName = 'CategoryBreadcrumbs';

export default CategoryBreadcrumbs;